import React from 'react';
import { workFormats } from '../data/materials';
export function WorkFormatSection() {
  return <section className="py-10 px-4 bg-gray-50" data-id="element-172" data-mp="3ig7cugmjtmpo">
      <div className="max-w-4xl mx-auto" data-id="element-173" data-mp="3iewbsokhmt29">
        <div className="text-center mb-8" data-id="element-174" data-mp="3n7phbens65fe">
          <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] leading-tight mb-2" data-id="element-175" data-mp="3n7z7p3cqmelm">
            NO SON 205 PÁGINAS PARA LEER.
            <br data-id="element-176" data-mp="2uirxv87u22l2" />
            <span className="text-[#157C8B]" data-id="element-177" data-mp="2ujbgkr5b4v05">
              SON 205 PÁGINAS PARA TRABAJAR.
            </span>
          </h2>
          <p className="text-base font-bold text-[#14356B] mb-1" data-id="element-178" data-mp="2ziweqzcnkzbt">
            205 PÁGINAS EN TOTAL
          </p>
          <p className="text-gray-600" data-id="element-179" data-mp="33hwuua3qxnv4">
            120 páginas de Catequesis + 85 páginas en 2 Bonus Premium.
          </p>
          <p className="text-gray-600 mt-2" data-id="element-180" data-mp="38ggj4h5tbbqn">
            Cada tema está pensado para que el alumno pueda:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-181" data-mp="nrsslab4y8xm">
          {workFormats.map(format => <div key={format.title} className="flex flex-col bg-white border border-gray-200 rounded-2xl p-5" data-id="element-182" data-mp="1bvxvk612q36k">
              <span className="text-2xl mb-2" aria-hidden="true" data-id="element-183" data-mp="16xcwwb1gzrk8">
                {format.emoji}
              </span>
              <h3 className="text-base font-black text-[#14356B] mb-1" data-id="element-184" data-mp="11vnjwpuot3ti">
                {format.title}
              </h3>
              <p className="text-base text-gray-700 mt-auto" data-id="element-185" data-mp="x087818f1dyo">
                {format.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}